// extracted by mini-css-extract-plugin
module.exports = {"box":"box--lVD9h","copy":"copy--dZmKo"};